module.exports = __webpack_public_path__ + "img/triangle.5eac9c41.svg";